import { getStyles as e } from "./style.js";
import { cn as t } from "../../cn.js";
import { FormErrorText as n, FormHelperText as r, FormSetErrorText as i, FormSetHelperText as a, FormSetLabel as o } from "../shared/form-primitives.js";
import { CheckIcon as s, MinusIcon as c } from "lucide-react";
import { jsx as l, jsxs as u } from "react/jsx-runtime";
import { Checkbox as d, Field as f, Fieldset as p } from "@ark-ui/react";
var m = Object.assign(({ label: i, config: a, className: o, errorText: p, helperText: m, indeterminate: h = !1, invalid: g = !1, ..._ }) => {
	let v = e({
		size: a?.size || "md",
		variant: a?.variant || "default",
		spacing: a?.spacing,
		orientation: a?.orientation
	}), y = a?.size === "sm" ? 12 : a?.size === "lg" ? 20 : 16, b = !!p || g;
	return /* @__PURE__ */ u(f.Root, {
		invalid: b,
		children: [
			/* @__PURE__ */ u(d.Root, {
				className: t(v.root(_.disabled), o),
				..._,
				...h ? { checked: "indeterminate" } : {},
				children: [
					/* @__PURE__ */ l("div", {
						className: v.controlWrapper(),
						children: /* @__PURE__ */ u(d.Control, {
							className: v.control(),
							children: [/* @__PURE__ */ l(d.Indicator, {
								className: v.indicator(),
								children: /* @__PURE__ */ l(s, {
									size: y,
									strokeWidth: 3
								})
							}), /* @__PURE__ */ l(d.Indicator, {
								indeterminate: !0,
								className: v.indicator(),
								children: /* @__PURE__ */ l(c, {
									size: y,
									strokeWidth: 3
								})
							})]
						})
					}),
					i && /* @__PURE__ */ l(d.Label, {
						className: v?.label(),
						children: i
					}),
					/* @__PURE__ */ l(d.HiddenInput, {})
				]
			}),
			m && !p && /* @__PURE__ */ l(r, { children: m }),
			p && /* @__PURE__ */ l(n, { children: p })
		]
	});
}, {
	Group: ({ children: n, className: r, config: i, value: a, ...o }) => {
		let s = e({
			spacing: i?.spacing,
			orientation: i?.orientation
		});
		return /* @__PURE__ */ l(d.Group, {
			className: t(s.group(), r),
			value: a ?? void 0,
			...o,
			children: n
		});
	},
	Root: ({ children: n, className: r, config: i, ...a }) => {
		let o = e({ size: i?.size || "md" });
		return /* @__PURE__ */ l(d.Root, {
			className: t(o.root(a.disabled), r),
			...a,
			children: n
		});
	},
	Label: ({ children: n, className: r, config: i, ...a }) => {
		let o = e({ size: i?.size || "md" });
		return /* @__PURE__ */ l(d.Label, {
			className: t(o.label(), r),
			...a,
			children: n
		});
	},
	Control: ({ children: n, className: r, config: i, ...a }) => {
		let o = e({
			size: i?.size || "md",
			variant: i?.variant || "default"
		});
		return /* @__PURE__ */ l("div", {
			className: o.controlWrapper(),
			children: /* @__PURE__ */ l(d.Control, {
				className: t(o.control(), r),
				...a,
				children: n
			})
		});
	},
	Indicator: ({ children: n, className: r, config: i, ...a }) => {
		let o = e({ size: i?.size || "md" });
		return /* @__PURE__ */ l(d.Indicator, {
			className: t(o.indicator(), r),
			...a,
			children: n
		});
	},
	HiddenInput: () => /* @__PURE__ */ l(d.HiddenInput, {}),
	Simple: ({ label: n, size: r = "md", variant: i = "default", className: a, ...o }) => {
		let c = e({
			size: r,
			variant: i
		}), f = r === "sm" ? 12 : r === "lg" ? 20 : 16;
		return /* @__PURE__ */ u(d.Root, {
			className: t(c.root(o.disabled), a),
			...o,
			children: [
				/* @__PURE__ */ l("div", {
					className: c.controlWrapper(),
					children: /* @__PURE__ */ l(d.Control, {
						className: c.control(),
						children: /* @__PURE__ */ l(d.Indicator, {
							className: c.indicator(),
							children: /* @__PURE__ */ l(s, {
								size: f,
								strokeWidth: 3
							})
						})
					})
				}),
				/* @__PURE__ */ l(d.Label, {
					className: c.label(),
					children: n
				}),
				/* @__PURE__ */ l(d.HiddenInput, {})
			]
		});
	},
	CheckboxGroup: ({ options: n, label: r, size: c = "md", variant: f = "default", orientation: m = "vertical", spacing: h = "none", className: g, helperText: _, errorText: v, required: y = !1, onValueChange: b, fieldsetProps: x, value: S, ...C }) => {
		let w = e({
			size: c,
			variant: f,
			spacing: h,
			orientation: m
		}), T = c === "sm" ? 12 : c === "lg" ? 20 : 16, E = (e) => {
			b && b(e);
		};
		return /* @__PURE__ */ l(p.Root, {
			invalid: !!v,
			...x,
			children: /* @__PURE__ */ u("div", {
				className: "flex flex-col gap-1",
				children: [
					r && /* @__PURE__ */ l(o, {
						required: y,
						disabled: C.disabled,
						children: r
					}),
					/* @__PURE__ */ l(d.Group, {
						className: t(w.group(), g),
						invalid: !!v,
						onValueChange: E,
						value: S ?? void 0,
						...C,
						children: n.map((e) => /* @__PURE__ */ u(d.Root, {
							value: e.value,
							disabled: e.disabled,
							className: w.root(e.disabled),
							children: [
								/* @__PURE__ */ l("div", {
									className: w.controlWrapper(),
									children: /* @__PURE__ */ l(d.Control, {
										className: w.control(),
										children: /* @__PURE__ */ l(d.Indicator, {
											className: w.indicator(),
											children: /* @__PURE__ */ l(s, {
												size: T,
												strokeWidth: 3
											})
										})
									})
								}),
								/* @__PURE__ */ l(d.Label, {
									className: w.label(),
									children: e.label
								}),
								/* @__PURE__ */ l(d.HiddenInput, {})
							]
						}, e.value))
					}),
					_ && !v && /* @__PURE__ */ l(a, { children: _ }),
					v && /* @__PURE__ */ l(i, { children: v })
				]
			})
		});
	},
	Indeterminate: ({ label: n, size: r = "md", variant: i = "default", className: a, ...o }) => {
		let f = e({
			size: r,
			variant: i
		}), p = r === "sm" ? 12 : r === "lg" ? 20 : 16;
		return /* @__PURE__ */ u(d.Root, {
			className: t(f.root(o.disabled), a),
			...o,
			children: [
				/* @__PURE__ */ l("div", {
					className: f.controlWrapper(),
					children: /* @__PURE__ */ u(d.Control, {
						className: f.control(),
						children: [/* @__PURE__ */ l(d.Indicator, {
							className: f.indicator(),
							children: /* @__PURE__ */ l(s, {
								size: p,
								strokeWidth: 3
							})
						}), /* @__PURE__ */ l(d.Indicator, {
							indeterminate: !0,
							className: f.indicator(),
							children: /* @__PURE__ */ l(c, {
								size: p,
								strokeWidth: 3
							})
						})]
					})
				}),
				/* @__PURE__ */ l(d.Label, {
					className: f.label(),
					children: n
				}),
				/* @__PURE__ */ l(d.HiddenInput, {})
			]
		});
	},
	ErrorText: ({ children: e, className: t, ...r }) => /* @__PURE__ */ l(n, {
		className: t,
		...r,
		children: e
	}),
	HelperText: ({ children: e, className: t, ...n }) => /* @__PURE__ */ l(r, {
		className: t,
		...n,
		children: e
	}),
	getStyles: e
});
export { m as Checkbox };

//# sourceMappingURL=index.js.map